import { CaretDownFilled } from '@ant-design/icons'
import { Button, Form, Modal, Row, Select, Space } from 'antd'
import moment from 'moment'
import 'moment/locale/zh-cn'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectInsuranceArray } from '../../../app/applicationSlice'
import {
  DateRangeDrugStaticTypes,
  DateRangeFieldName,
  DateRangeType,
  DateSelect,
  getDateRange,
  TJFXTime,
} from '../../../compnents/form/DateSelect'
import { PrintOutlined } from '../../../compnents/icons/Icons'
import { revenueReport } from '../../../models/revenueReport'
import { getCheckPermissionAsync } from '../../FunctionSetting/dataPermission/dataPermissionSlice'
import { SJQXChecks } from '../../../models/dataPersion'
import { unwrapResult } from '@reduxjs/toolkit'
import { RootDispatch } from '../../../app/store'
import styles from './revent.module.css'
import { getChainListAsync } from '../../warehouseStatement/allReport/warehouseChangeReport/warehouseChangeReportSlice'
const { Option } = Select

export const RevenueReportQuery = (props: {
  loading?: any
  exportloading?: any
  onValueChange: (queries: revenueReport) => void
  outClued: () => void
  print: () => void
  alertMessage: () => void
}): ReactElement => {
  const [form] = Form.useForm()

  const storageParams = JSON.parse(
    sessionStorage.getItem(location.pathname+"_yingshoubaobiao") || '{}'
  ) 

  const insuranceArray = useSelector(selectInsuranceArray)

  const dispatch = useDispatch<RootDispatch>()
  
  useEffect(() => {
    const [head, tail] = getDateRange(DateRangeType.Today);

    if (
      Object.keys(storageParams).length
    ) {
      form.setFieldsValue({
        ...storageParams,
        // 页面进入时时间范围默认今天，不恢复上次保存的时间范围
        timeHead: head,
        timeTail: tail,
        [DateRangeFieldName]: DateRangeType.Today,
      })
    } else {
      form.setFieldsValue({
        _dateRange: 0,
        timeHead: head,
        timeTail: tail,
      })
    }

    form.submit();
  }, []);

  const refresh = () => {
    props.onValueChange({
      ...storageParams,
      ...form.getFieldsValue(),
    });
  };

  const [isInTimeRange, setIsInTimeRange] = useState(false)

  const checkTimeRange = () => {
    const now = moment()
    const currentHour = now.hours()

    // 判断当前时间是否在给定的时间段内
    if (
      (currentHour >= 10 && currentHour < 12) ||
      (currentHour === 12 && now.minutes() === 0) ||
      (currentHour >= 14 && currentHour < 16) ||
      (currentHour >= 19 && currentHour <= 23) ||
      (currentHour >= 0 && currentHour < 6)
    ) {
      setIsInTimeRange(true)
    } else {
      setIsInTimeRange(false)
    }
  }

  useEffect(() => {
    checkTimeRange()
  }, [])

  return (
    <>
      <Form
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
        form={form}
        onFinish={(vs) => props.onValueChange(vs)}
      >
        <Row
          style={{ marginBottom: 10, width: '100%' }}
          align='middle'
          justify='space-between'
        >
          <Space>
            <DateSelect
              style={{ width: '8.5rem' }}
              labelPrefix=''
              allowClear={false}
              options={DateRangeDrugStaticTypes}
              namePrefix='time'
              placeholder='日期范围-时间'
              initialValue={DateRangeType.Today}
              onChange={() => {
                refresh();
              }}
            />
            {insuranceArray && insuranceArray.length !== 0 && (
              <Form.Item name='insuranceCode' noStyle>
                <Select
                  placeholder='险种类型'
                  style={{ width: '8.25rem' }}
                  allowClear
                  // suffixIcon={<CaretDownFilled />}
                  onChange={() => {
                    refresh();
                  }}
                >
                  <Select.Option value={''}>全部</Select.Option>
                  <Select.Option value={'ZIFEI'}>自费</Select.Option>
                  {insuranceArray.map((v) => (
                    <Select.Option value={v.insuranceCode} key={v.id}>
                      {v.insuranceName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            )}
            <Button
              loading={props.loading}
              type='primary'
              onClick={() => refresh()}
            >
              查询
            </Button>
          </Space>
          <Space>
            <Button
              type='text'
              style={{
                color: '#666',
                display: 'flex',
                alignItems: 'center',
              }}
              onClick={() => {
                dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.DCDYQX }))
                  .then(unwrapResult)
                  .then((res: any) => {
                    props.print()
                  })
              }}
            >
              <PrintOutlined
                style={{
                  fill: '#666',
                  width: '18px',
                  height: '18px',
                  marginRight: '4px',
                }}
              />
              打印
            </Button>
            <Button type='primary' onClick={() => {
              dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.DCDYQX }))
                .then(unwrapResult)
                .then((res: any) => {
                   props.outClued()
                })
            }} loading={props.exportloading}>
              导出
            </Button>
            {isInTimeRange ? (
            <div
              style={{
                opacity: 0,
                cursor: 'pointer',
                width: '10px',
                height: '30px',
              }}
              onDoubleClick={() => {
                props?.alertMessage && props?.alertMessage()
              }}
            ></div>
          ) : (
            <></>
          )}
          </Space>
        </Row>
      </Form>
    </>
  )
}

export const RevenueReportChainQuery = (props: {
  loading?: any
  exportloading?: any
  onValueChange: (queries: revenueReport) => void
  outClued: () => void
  print: () => void
  alertMessage: () => void
}): ReactElement => {
  const [form] = Form.useForm()

  const [organizationData, setOrganizationData] = useState<any>([])

  const storageParams = JSON.parse(
    sessionStorage.getItem(location.pathname+"_yingshoubaobiao") || '{}'
  ) 

  const insuranceArray = useSelector(selectInsuranceArray)

  const dispatch = useDispatch<RootDispatch>()
  
  useEffect(() => {
    const [head, tail] = getDateRange(DateRangeType.Today);

    if (
      Object.keys(storageParams).length
    ) {
      form.setFieldsValue({
        ...storageParams,
        tenantIds: storageParams?.tenantIds ? storageParams?.tenantIds?.split(',') : []  ,
        timeHead: storageParams?.timeHead || head,
        timeTail: storageParams?.timeTail || tail,
        [DateRangeFieldName]: storageParams?._dateRange || DateRangeType.Today,
      })
    } else {
      form.setFieldsValue({
        _dateRange: 0,
        timeHead: head,
        timeTail: tail,
      })
    }

    form.submit();
  }, []);

  const refresh = () => {
    props.onValueChange({
      ...storageParams,
      ...form.getFieldsValue(),
      tenantIds: form.getFieldValue('tenantIds')?.join(',') || '' ,
    });
  };

  const [isInTimeRange, setIsInTimeRange] = useState(false)

  const checkTimeRange = () => {
    const now = moment()
    const currentHour = now.hours()

    // 判断当前时间是否在给定的时间段内
    if (
      (currentHour >= 10 && currentHour < 12) ||
      (currentHour === 12 && now.minutes() === 0) ||
      (currentHour >= 14 && currentHour < 16) ||
      (currentHour >= 19 && currentHour <= 23) ||
      (currentHour >= 0 && currentHour < 6)
    ) {
      setIsInTimeRange(true)
    } else {
      setIsInTimeRange(false)
    }
  }

  useEffect(() => {
    checkTimeRange()
  }, [])

  useEffect(() => {
    dispatch(getChainListAsync())
      .then(unwrapResult)
      .then((res: any) => {
        setOrganizationData(res)
      })
  }, [])

  return (
    <>
      <Form
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
        form={form}
        onFinish={(vs) => props.onValueChange({...vs, tenantIds:vs?.tenantIds?.join(',') || '' })}
      >
        <Row
          style={{ marginBottom: 10, width: '100%' }}
          align='middle'
          justify='space-between'
        >
          <Space>
            <Form.Item name='tenantIds' noStyle>
              <Select
                placeholder='机构名称'
                allowClear
                mode='multiple'
                dropdownClassName={styles.selectDropdown}
                style={{ minWidth: 150, maxWidth: 410 }}
                onChange={() => {
                  refresh()
                }}
              >
                {/* <Select.Option key={' '} value={' '}>
                  全部
                </Select.Option> */}
                {organizationData?.map((v: any) => {
                  return (
                    <Option value={v?.id?.toString()} key={v?.id}>
                      {v?.name}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
            <DateSelect
              style={{ width: '8.5rem' }}
              labelPrefix=''
              allowClear={false}
              options={DateRangeDrugStaticTypes}
              namePrefix='time'
              placeholder='日期范围-时间'
              initialValue={DateRangeType.Today}
              onChange={() => {
                refresh();
              }}
            />
            {insuranceArray && insuranceArray.length !== 0 && (
              <Form.Item name='insuranceCode' noStyle>
                <Select
                  placeholder='险种类型'
                  style={{ width: '8.25rem' }}
                  allowClear
                  // suffixIcon={<CaretDownFilled />}
                  onChange={() => {
                    refresh();
                  }}
                >
                  <Select.Option value={''}>全部</Select.Option>
                  <Select.Option value={'ZIFEI'}>自费</Select.Option>
                  {insuranceArray.map((v) => (
                    <Select.Option value={v.insuranceCode} key={v.id}>
                      {v.insuranceName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            )}
            <Button
              loading={props.loading}
              type='primary'
              onClick={() => refresh()}
            >
              查询
            </Button>
          </Space>
          <Space>
            <Button
              type='text'
              style={{
                color: '#666',
                display: 'flex',
                alignItems: 'center',
              }}
              onClick={() => {
                dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.DCDYQX }))
                  .then(unwrapResult)
                  .then((res: any) => {
                    props.print()
                  })
              }}
            >
              <PrintOutlined
                style={{
                  fill: '#666',
                  width: '18px',
                  height: '18px',
                  marginRight: '4px',
                }}
              />
              打印
            </Button>
            <Button type='primary' onClick={() => {
              dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.DCDYQX }))
                .then(unwrapResult)
                .then((res: any) => {
                   props.outClued()
                })
            }} loading={props.exportloading}>
              导出
            </Button>
            {isInTimeRange ? (
            <div
              style={{
                opacity: 0,
                cursor: 'pointer',
                width: '10px',
                height: '30px',
              }}
              onDoubleClick={() => {
                props?.alertMessage && props?.alertMessage()
              }}
            ></div>
          ) : (
            <></>
          )}
          </Space>
        </Row>
      </Form>
    </>
  )
}

